import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Sprint } from "../../interfaces/sprint";
import { Router } from "@angular/router";

@Injectable()
export class SprintService {
  env: any = environment;

  constructor(private http: HttpClient, private router: Router) {}

  getSprintsByProjectId(projectId): Promise<Sprint[]> {
    return new Promise((resolve, reject) => {
      const params = new HttpParams().set("projectId", projectId);
      this.http
        .get<any>(this.env.managirUrl + "/sprints", {
          params: params,
          headers: { "Content-Type": "application/json" },
        })
        .toPromise()
        .then((response) => {
          resolve(response.SprintResponse.sprints);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  }

  getSprintByShortId(shortId): Promise<Sprint> {
    return new Promise((resolve, reject) => {
      const params = new HttpParams().set("shortId", shortId);
      this.http
        .get<any>(this.env.managirUrl + "/sprints", {
          params: params,
          headers: { "Content-Type": "application/json" },
        })
        .toPromise()
        .then((response) => {
          resolve(response.SprintResponse.sprints[0]);
        })
        .catch((error) => {
          reject(error);
          /**
           * check if user has access on project and if project does exist
           */
          // if (error.status === 404 || error.status === 403) {
          //   this.router.navigate(['/' + error.status]);
          // }
        });
    });
  }

  createSprint(sprint): Promise<Sprint> {
    return new Promise((resolve, reject) => {
      this.http
        .post<any>(this.env.managirUrl + "/sprints", sprint, {
          headers: { "Content-Type": "application/json" },
        })
        .toPromise()
        .then((response) => {
          resolve(response.SprintResponse.sprints[0]);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  }

  saveSprint(sprint) {
    return new Promise((resolve, reject) => {
      this.http
        .put<any>(this.env.managirUrl + "/sprints/" + sprint._id, sprint, {
          headers: { "Content-Type": "application/json" },
        })
        .toPromise()
        .then((response) => {
          resolve(response.SprintResponse.sprints[0]);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  }

  deleteSprintById(sprintId) {
    return new Promise((resolve, reject) => {
      this.http
        .delete<any>(this.env.managirUrl + "/sprints/" + sprintId, {
          headers: { "Content-Type": "application/json" },
        })
        .toPromise()
        .then((response) => {
          resolve(response.message);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  }
}



// WEBPACK FOOTER //
// /agir/src/app/services/sprint/sprint.service.ts